var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSettingsOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.35 9.708 19 11.979v.042l2.349 2.271a1 1 0 0 1 .17 1.22l-1.718 2.977a1 1 0 0 1-1.141.461l-3.14-.898-.038.022-.793 3.168a1 1 0 0 1-.97.758h-3.438a1 1 0 0 1-.97-.758l-.792-3.168-.039-.022-3.14.898a1 1 0 0 1-1.14-.461L2.48 15.51a1 1 0 0 1 .171-1.219l2.35-2.271v-.041L2.65 9.707a1 1 0 0 1-.17-1.22l1.718-2.977A1 1 0 0 1 5.34 5.05l3.14.898.039-.022.792-3.169A1 1 0 0 1 10.28 2h3.438a1 1 0 0 1 .97.757l.793 3.169.038.022 3.14-.898a1 1 0 0 1 1.14.461l1.72 2.978a1 1 0 0 1-.17 1.219Zm-7.602-2.472.737.424.028.016.737.43 3.21-.919.938 1.626-2.4 2.32.002.852v.03l-.003.852 2.4 2.32-.938 1.626-3.21-.918-.736.43-.028.015-.737.424-.81 3.236h-1.876l-.81-3.236-.737-.424-.028-.016-.737-.43-3.209.919-.938-1.626 2.4-2.32L7 12.015v-.03l.003-.852-2.4-2.32.938-1.626 3.21.918.736-.43.028-.015.737-.424.81-3.236h1.877l.809 3.236Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSettingsOutlined);
export default __webpack_public_path__ + "static/media/ic_action_settings_outlined.08e9f15d8b857dbed46adcd68f9d045c.svg";
export { ForwardRef as ReactComponent };